module.exports = __webpack_public_path__ + "img/box-edevlet.b66219d7.svg";